//* Libraries imports
import { useQuery } from "@tanstack/react-query";

//* Schemas Import
import { fullResultExtended } from "../../../schemas/common/result";
import { createResponseFullSchema } from "../../../schemas/api-response";

//* Axios Import
import { privateApi } from "../../../services/apis/configs/apiClient";

const resultResponseSchema = createResponseFullSchema(fullResultExtended);



/**
 * API para recursos
 */
const ResultAPI = {

  /**
   * Obtém detalhes de uma questão específica dentro de um caderno de respostas
   * @param examId ID do caderno de respostas
   * @param questaoId ID da questão específica
   * @returns Detalhes completos da questão ou erro
   */
  getByIdDetails: async function (examId: number | undefined, questaoId: number | undefined) {
    try {      
      
      const response = await privateApi.get(
        `/student_portal/private/caderno-respostas/${examId}/questao/${questaoId}`
      );      
      
      const validatedResponse = resultResponseSchema.parse(response);
      
      return {
        data: validatedResponse.data.questao,
        success: true,
      };

      
    } catch (error) {
      console.error(`Erro ao buscar questão ${questaoId} do caderno ${examId}:`, error);
      return {
        data: null,
        success: false,
        message:
          "Não foi possível carregar os detalhes da questão. Tente novamente mais tarde.",
      };
    }
  },
};



/**
 * Hook para obter detalhes de uma questão específica dentro de um caderno de respostas
 * @param examId ID do caderno de respostas
 * @param questaoId ID da questão específica
 * @param enabled Se a query deve ser habilitada (default: true)
 * @returns Query para detalhes completos da questão
 */
export const useGetResultDetails = (
  examId: number | undefined,
  questaoId: number | undefined,
  enabled: boolean = true
) => {
  return useQuery({
    queryKey: ["resource-question-details", examId, questaoId],
    queryFn: async () => await ResultAPI.getByIdDetails(examId, questaoId),
    retry: 2,
    staleTime: 1000 * 60 * 5,
    enabled: !!examId && !!questaoId && enabled,
  });
};
